import React from "react";
import StartGameModal from "./StartGameModal";

const InfoPanel = ({ round, startGame, time, isGameProccess }) => {
  return (
    <div className="info-panel">
      <div className="content">{`ROUND №: ${round || ""}`}</div>
      {/* {!isGameProccess && <div className="content">{time}</div>} */}
      <div className="button-container">
        <span className="start">
          <StartGameModal startGame={startGame} />
        </span>
      </div>
    </div>
  );
};

export default InfoPanel;
